import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { designModerationApi } from "../api/designModerationApi";
import type { ListDesignsQuery, ModerateDesignBody } from "../types";

export const designModerationKeys = {
  all: ["admin-designs"] as const,
  list: (query?: ListDesignsQuery) =>
    [...designModerationKeys.all, "list", query ?? {}] as const,
};

export const useDesignsList = (query: ListDesignsQuery) =>
  useQuery({
    queryKey: designModerationKeys.list(query),
    queryFn: () => designModerationApi.listDesigns(query),
  });

export const useModerateDesign = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: ModerateDesignBody }) =>
      designModerationApi.moderateDesign(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: designModerationKeys.all });
    },
  });
};
